<template>
  <div
    v-if="!_isEmpty(socialMedia)"
    class="flex flex-wrap gap-2 md:gap-4"
    :data-testid="dataTestid"
  >
    <!-- -mt-2 md:mt-0 -->
    <V2AtomsButton
      v-for="(item, itemIndex) in socialMedia"
      :key="`social-media-${itemIndex}`"
      :size="buttonSize"
      theme="secondary"
      :to="item?.url"
      :target="item?.target"
      has-icon-left
    >
      <template #icon-left>
        <component
          :is="item.component"
          class="wh-5"
        />
      </template>

      {{ item?.name }}
    </V2AtomsButton>
  </div>
</template>

<script setup>
import _isEmpty from 'underscore/cjs/isEmpty.js'

defineOptions({
  name: 'V2MoleculesAuthorSocialMediaList'
})

const props = defineProps({
  dataTestid: {
    type: String,
    default: 'social-media-list'
  },

  list: {
    type: Array,
    default: () => []
  },

  buttonSize: {
    type: String,
    default: 'small',
    validator: value => ['x-small', 'small', 'base', 'large'].includes(value)
  }
})

const componentMap = {
  V2IconsEnvelope: resolveComponent('V2IconsEnvelope'),
  V2IconsTwitter: resolveComponent('V2IconsTwitter'),
  V2IconsLinkedin: resolveComponent('V2IconsLinkedin')
}

const socialMedia = computed(() => {
  if (_isEmpty(props.list)) {
    return []
  }

  const imageMap = {
    Twitter: 'V2IconsTwitter',
    Email: 'V2IconsEnvelope',
    Linkedin: 'V2IconsLinkedin'
  }

  return props.list?.map(item => {
    const name = item?.name.includes('Email')
      ? 'Email'
      : item?.name

    return {
      name,
      component: componentMap?.[getKey(name, imageMap, '')],
      url: item?.url,
      target: ['Twitter', 'Linkedin'].includes(name) ? '_blank' : undefined
    }
  })
})
</script>
